import { render, staticRenderFns } from "./MakeCutReturn.vue?vue&type=template&id=4a31c765"
import script from "./MakeCutReturn.vue?vue&type=script&lang=js"
export * from "./MakeCutReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports